import React from 'react'

import { GetCustomerAutoShipsDocument } from '../../../../graphql/camel'
import useCamelQuery from '../../../../hooks/useCamelQuery'
import useLogAndCaptureError from '../../../../hooks/useLogAndCaptureError'
import useSiteMetadata from '../../../../hooks/useSiteMetadata'
import useUserCategory from '../../../../hooks/useUserCategory'
import QueryFallback from '../QueryFallback'
import AutoShipPageContent from './AutoShipPageContent'
import { AutoShipAbstract, AutoShipHR, AutoShipIntro, Container } from './styled'

const AutoShipContainer: React.VFC = () => {
  const { data, error, loading, refetch } = useCamelQuery(GetCustomerAutoShipsDocument, {
    notifyOnNetworkStatusChange: true,
  })
  useLogAndCaptureError(error)

  const { userCategory } = useUserCategory()
  const { featureFlags } = useSiteMetadata() ?? {}

  return (
    <Container>
      <AutoShipIntro>
        <h3>Auto-Ship</h3>
        {userCategory === 'practitioner' && !!featureFlags?.autoShipAndSave && (
          <AutoShipAbstract>
            <p>Your Designs for Health virtual dispensary offers 5% OFF on all Auto-Ship orders!</p>
            <p>
              The Auto-Ship & Save feature is an easy way to boost adherence and maintain regular
              engagement with your patients by automatically providing a 5% discount on all
              subscription orders. Discounts can impact the margin you earn on some orders placed in
              your dispensary. However, offering patients savings on their health and wellness
              routine provides an ongoing revenue stream for you and increases payouts long-term.
            </p>
          </AutoShipAbstract>
        )}
      </AutoShipIntro>
      <AutoShipHR />
      {!!error && !loading && (
        <QueryFallback
          buttonText="Retry Loading Auto-Ships"
          error={error}
          onRetry={() => refetch()}
        />
      )}
      <AutoShipPageContent data={data} loading={loading} />
    </Container>
  )
}

export default AutoShipContainer
